/* import __COLOCATED_TEMPLATE__ from './loading-information.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './loading-information.module.scss';

@classic
@classNames(styles.component)
export default class RequestStepsLoadingLoadingInformation extends Component {}
